import { render, staticRenderFns } from "./resourcesSession.vue?vue&type=template&id=01ab7fde&scoped=true&"
import script from "./resourcesSession.vue?vue&type=script&lang=js&"
export * from "./resourcesSession.vue?vue&type=script&lang=js&"
import style0 from "./resourcesSession.vue?vue&type=style&index=0&id=01ab7fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab7fde",
  null
  
)

export default component.exports